













































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Accordion from "../../shared/Accordion.vue";
import { ShipmentDTO } from "../../../model/data.model";
import { isFrance, isSpain } from "@/services/Helpers";
import { requiredIf } from "vuelidate/lib/validators";
import { MBEShipServiceBusiness } from "@/model/enumeration.model";

@Component({
  validations() {
    return {
      shipment: {
        goodDescription: {
          required: requiredIf(function(this: NewShipmentNotes) {
            return this.goodDescriptionRequired();
          })
        }
      }
    };
  },
  components: {
    Accordion: Accordion
  }
})
export default class NewShipmentNotes extends Vue {
  @Prop() shipment: ShipmentDTO;
  @Prop() edition: boolean;
  @Prop() selectedFromCEE: boolean;
  @Prop() selectedToCEE: boolean;

  accordionOpened = false;

  get isInboundShipment() {
    return (
      this.$route.query.type === "inbound" &&
      this.$store.getters.features.inbound
    );
  }

  changedAccordionState(state: boolean) {}

  goodDescriptionRequired(): boolean {
    if (this.isInboundShipment) {
      return true;
    }
    if (isFrance() || isSpain()) return true;
    if (
      this.shipment.mbeServiceId ===
        MBEShipServiceBusiness.GEL_PROXIMITY_POINT ||
      this.shipment.mbeServiceId === MBEShipServiceBusiness.MBE_ACCESS_POINT
    )
      return true;
    return (
      this.edition &&
      (this.shipment.shipmentType !== "DOMESTIC" || !this.shipment.shipmentType)
    );
  }
}
